<template>
  <svg :width="width" :height="height" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M1.66699 10.0003H3.33366V14.167H16.667V10.0003H18.3337V14.167C18.3337 15.092 17.592 15.8337 16.667 15.8337H3.33366C2.41699 15.8337 1.66699 15.092 1.66699 14.167V10.0003ZM10.0003 12.5003L14.6253 7.95033L13.442 6.77533L10.8337 9.37533V1.66699H9.16699V9.37533L6.56699 6.77533L5.38366 7.95866L10.0003 12.5003Z" :fill="iconColor"/>
</svg>
</template>

<script>
export default {
  props: {
    iconName: {
      type: String,
      default: "iconArrowDownload",
    },
    width: {
      type: [Number, String],
      default: 20,
    },
    height: {
      type: [Number, String],
      default: 20,
    },
    iconColor: {
      type: String,
      default: "currentColor",
    },
  },
};
</script>
